export default __webpack_public_path__ + "static/media/TELMI_Poziom_Biel-Kolor_animation2.f0e2ad4f.svg";